export default __webpack_public_path__ + "static/media/loader.f843027c.svg";